import { CSSProperties, FC, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { useBackButtonToPrevRoute } from '@/hooks/useBackButtonToPrevRoute.tsx';
import { routes } from '@/navigation/routes.tsx';
import { InputContent } from '@/components/common/InputContent/InputContent.tsx';
import { MainButton } from '@/components/common/MainButton/MainButton.tsx';
import { helpers } from '@/helpers.ts';
import ArrowRightShape from '@/components/common/svg/shapes/ArrowRightShape.tsx';
import { blockContainer } from '@/pages/Profile/Settings/styles.ts';

interface FAQItem {
  questionKey: string;
  answerKey: string;
}

const faqItems: FAQItem[] = [
  {
    questionKey: 'support.faq.moderation_time.question',
    answerKey: 'support.faq.moderation_time.answer'
  },
  {
    questionKey: 'support.faq.delete_profile.question',
    answerKey: 'support.faq.delete_profile.answer'
  }
];

const Support: FC = () => {
  useBackButtonToPrevRoute(routes.profileSettings, false);
  const { t } = useTranslation();
  const [expandedIndex, setExpandedIndex] = useState<number | null>(null);

  const handleToggle = (index: number) => {
    setExpandedIndex(expandedIndex === index ? null : index);
  };

  const handleContactSupport = () => {
    window.open(
      helpers.getEnvVar(
        'VITE_SUPPORT_BOT_DEEPLINK',
        'https://t.me/KyivDateSupport'
      ),
      '_blank'
    );
  };

  return (
    <div style={containerStyle}>
      <InputContent title={t('support.page_title')}>
        <div style={{ ...blockContainer, overflow: 'hidden' }}>
          {faqItems.map((item, index) => (
            <div key={index} style={faqItemStyle}>
              <button
                onClick={() => handleToggle(index)}
                style={questionButtonStyle}
              >
                <span style={questionTextStyle}>{t(item.questionKey)}</span>
                <div
                  style={{
                    transform:
                      expandedIndex === index
                        ? 'rotate(270deg)'
                        : 'rotate(90deg)'
                  }}
                >
                  <ArrowRightShape width={16} height={16} fillColor="#999" />
                </div>
              </button>
              {expandedIndex === index && (
                <div style={answerContainerStyle}>
                  <p style={answerTextStyle}>{t(item.answerKey)}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </InputContent>
      <MainButton
        onClick={handleContactSupport}
        text={t('support.still_have_questions')}
        fixed
      />
    </div>
  );
};

const containerStyle: CSSProperties = {
  height: 'calc(100vh - 100px)',
  paddingTop: '100px',
  display: 'flex',
  flexDirection: 'column'
};

const faqItemStyle: CSSProperties = {
  borderBottom: '1px solid rgba(0, 0, 0, 0.04)'
};

const questionButtonStyle: CSSProperties = {
  width: '100%',
  padding: '18px 16px',
  height: '64px',
  boxSizing: 'border-box',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  backgroundColor: 'transparent',
  border: 'none',
  cursor: 'pointer',
  textAlign: 'left'
};

const questionTextStyle: CSSProperties = {
  fontSize: '15px',
  fontWeight: '500',
  color: '#000000',
  flex: 1,
  paddingRight: '12px',
  lineHeight: '1.3',
  display: '-webkit-box',
  WebkitLineClamp: 2,
  WebkitBoxOrient: 'vertical',
  overflow: 'hidden'
};

const answerContainerStyle: CSSProperties = {
  padding: '16px',
  backgroundColor: '#F8F8FA',
  borderTop: '1px solid rgba(0, 0, 0, 0.04)'
};

const answerTextStyle: CSSProperties = {
  margin: 0,
  fontSize: '15px',
  lineHeight: '1.5',
  color: '#4A4A4A'
};

export default Support;
